import React, { useState } from 'react';
import axios from 'axios';

const ReviewWearModal = ({ entry, token, onClose, onSuccess }) => {
  const [form, setForm] = useState({
    occasion: entry.occasion || '',
    weather: entry.weather || '',
    temperature: entry.temperature || '',
    longevity_rating: entry.longevity_rating || '',
    sillage_rating: entry.sillage_rating || '',
    compliments: entry.compliments || '',
    mood: entry.mood || '',
    notes: entry.notes || '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const API = process.env.REACT_APP_API_URL;
  const set = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const handleSubmit = async () => {
    setLoading(true);
    setError('');
    try {
      await axios.patch(
        `${API}/api/journal/${entry.id}`,
        {
          ...form,
          temperature: form.temperature ? parseInt(form.temperature) : null,
          compliments: form.compliments ? parseInt(form.compliments) : null,
          completed: true,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    }
    setLoading(false);
  };

  const styles = {
    overlay: {
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.85)',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      backdropFilter: 'blur(4px)',
    },
    modal: {
      background: '#111111',
      border: '1px solid #2a2a2a',
      width: '100%',
      maxWidth: '520px',
      maxHeight: '90vh',
      overflowY: 'auto',
      position: 'relative',
      padding: '48px',
    },
    close: {
      position: 'absolute',
      top: '20px',
      right: '24px',
      background: 'none',
      border: 'none',
      color: '#a09890',
      fontSize: '1rem',
      cursor: 'pointer',
    },
    eyebrow: {
      fontFamily: 'Jost, sans-serif',
      fontSize: '0.7rem',
      letterSpacing: '0.4em',
      textTransform: 'uppercase',
      color: '#c9a96e',
      marginBottom: '8px',
    },
    brand: {
      fontFamily: 'Jost, sans-serif',
      fontSize: '0.65rem',
      letterSpacing: '0.3em',
      textTransform: 'uppercase',
      color: '#c9a96e',
      marginBottom: '6px',
    },
    name: {
      fontFamily: 'Cormorant Garamond, serif',
      fontSize: '2rem',
      fontWeight: 300,
      color: '#f5f0eb',
      marginBottom: '8px',
      lineHeight: 1.1,
    },
    sprays: {
      fontFamily: 'Jost, sans-serif',
      fontSize: '0.75rem',
      fontWeight: 300,
      color: '#665e58',
      marginBottom: '32px',
    },
    divider: {
      border: 'none',
      borderTop: '1px solid #2a2a2a',
      margin: '24px 0',
    },
    label: {
      fontFamily: 'Jost, sans-serif',
      fontSize: '0.65rem',
      letterSpacing: '0.2em',
      textTransform: 'uppercase',
      color: '#a09890',
      marginBottom: '8px',
      display: 'block',
    },
    select: {
      width: '100%',
      background: '#1a1a1a',
      border: '1px solid #2a2a2a',
      padding: '12px 16px',
      color: '#f5f0eb',
      fontFamily: 'Jost, sans-serif',
      fontSize: '0.85rem',
      fontWeight: 300,
      marginBottom: '20px',
      outline: 'none',
      cursor: 'pointer',
      appearance: 'none',
      boxSizing: 'border-box',
    },
    input: {
      width: '100%',
      background: '#1a1a1a',
      border: '1px solid #2a2a2a',
      padding: '12px 16px',
      color: '#f5f0eb',
      fontFamily: 'Jost, sans-serif',
      fontSize: '0.85rem',
      fontWeight: 300,
      marginBottom: '20px',
      outline: 'none',
      boxSizing: 'border-box',
    },
    row: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '16px',
    },
    textarea: {
      width: '100%',
      background: '#1a1a1a',
      border: '1px solid #2a2a2a',
      padding: '12px 16px',
      color: '#f5f0eb',
      fontFamily: 'Jost, sans-serif',
      fontSize: '0.85rem',
      fontWeight: 300,
      marginBottom: '24px',
      outline: 'none',
      resize: 'vertical',
      height: '80px',
      boxSizing: 'border-box',
    },
    button: {
      width: '100%',
      background: '#c9a96e',
      border: 'none',
      padding: '16px',
      color: '#0a0a0a',
      fontFamily: 'Jost, sans-serif',
      fontSize: '0.75rem',
      letterSpacing: '0.2em',
      textTransform: 'uppercase',
      cursor: 'pointer',
    },
    skipBtn: {
      width: '100%',
      background: 'none',
      border: '1px solid #2a2a2a',
      padding: '12px',
      color: '#665e58',
      fontFamily: 'Jost, sans-serif',
      fontSize: '0.65rem',
      letterSpacing: '0.2em',
      textTransform: 'uppercase',
      cursor: 'pointer',
      marginTop: '12px',
    },
    error: {
      color: '#e07070',
      fontFamily: 'Jost, sans-serif',
      fontSize: '0.8rem',
      marginBottom: '16px',
    },
    sectionLabel: {
      fontFamily: 'Jost, sans-serif',
      fontSize: '0.6rem',
      letterSpacing: '0.3em',
      textTransform: 'uppercase',
      color: '#665e58',
      marginBottom: '16px',
    },
  };

  return (
    <div style={styles.overlay} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={styles.modal}>
        <button style={styles.close} onClick={onClose}>✕</button>

        <p style={styles.eyebrow}>How Did It Do?</p>
        <p style={styles.brand}>{entry.brand}</p>
        <p style={styles.name}>{entry.name}</p>
        <p style={styles.sprays}>{entry.sprays} spray{entry.sprays !== 1 ? 's' : ''} this morning</p>

        {/* Performance */}
        <div style={styles.row}>
          <div>
            <label style={styles.label}>Longevity</label>
            <select style={styles.select} value={form.longevity_rating} onChange={e => set('longevity_rating', e.target.value)}>
              <option value="">Select...</option>
              <option value="1">Faded within 2 hours</option>
              <option value="2">Lasted ~4 hours</option>
              <option value="3">Lasted ~6 hours</option>
              <option value="4">Lasted all day</option>
              <option value="5">Still going next morning</option>
            </select>
          </div>
          <div>
            <label style={styles.label}>Projection</label>
            <select style={styles.select} value={form.sillage_rating} onChange={e => set('sillage_rating', e.target.value)}>
              <option value="">Select...</option>
              <option value="1">Only I could smell it</option>
              <option value="2">Close range only</option>
              <option value="3">People nearby noticed</option>
              <option value="4">Filled the room</option>
              <option value="5">Left a trail everywhere</option>
            </select>
          </div>
        </div>

        <hr style={styles.divider} />
        <p style={styles.sectionLabel}>Optional Details</p>

        {/* Occasion & Mood */}
        <div style={styles.row}>
          <div>
            <label style={styles.label}>Occasion</label>
            <select style={styles.select} value={form.occasion} onChange={e => set('occasion', e.target.value)}>
              <option value="">Select...</option>
              <option>Casual</option>
              <option>Office</option>
              <option>Evening</option>
              <option>Date</option>
              <option>Sport</option>
              <option>Night Out</option>
            </select>
          </div>
          <div>
            <label style={styles.label}>Mood</label>
            <select style={styles.select} value={form.mood} onChange={e => set('mood', e.target.value)}>
              <option value="">Select...</option>
              <option>Confident</option>
              <option>Relaxed</option>
              <option>Romantic</option>
              <option>Energetic</option>
              <option>Professional</option>
              <option>Adventurous</option>
            </select>
          </div>
        </div>

        {/* Weather & Temp */}
        <div style={styles.row}>
          <div>
            <label style={styles.label}>Weather</label>
            <select style={styles.select} value={form.weather} onChange={e => set('weather', e.target.value)}>
              <option value="">Select...</option>
              <option>Sunny</option>
              <option>Cloudy</option>
              <option>Rainy</option>
              <option>Snowy</option>
              <option>Humid</option>
              <option>Windy</option>
            </select>
          </div>
          <div>
            <label style={styles.label}>Temperature (°C)</label>
            <input
              style={styles.input}
              type="number"
              placeholder="e.g. 18"
              value={form.temperature}
              onChange={e => set('temperature', e.target.value)}
            />
          </div>
        </div>

        {/* Compliments */}
        <label style={styles.label}>Compliments Received</label>
        <input
          style={styles.input}
          type="number"
          min="0"
          placeholder="How many compliments?"
          value={form.compliments}
          onChange={e => set('compliments', e.target.value)}
        />

        {/* Notes */}
        <label style={styles.label}>Notes</label>
        <textarea
          style={styles.textarea}
          placeholder="How did it wear today?"
          value={form.notes}
          onChange={e => set('notes', e.target.value)}
        />

        {error && <p style={styles.error}>{error}</p>}

        <button style={styles.button} onClick={handleSubmit} disabled={loading}>
          {loading ? 'Saving...' : 'Save Review'}
        </button>

        <button style={styles.skipBtn} onClick={onClose}>
          Come back later
        </button>
      </div>
    </div>
  );
};

export default ReviewWearModal;